import { BaseShortcut } from '@shared/directives/shortcuts/base-shortcut';
import { Directive } from '@angular/core';

@Directive({
  selector: 'browser-shortcut-disabler-directive',
})
export class BrowserShortcutDisabler extends BaseShortcut {
  constructor() {
    super();
  }

  onKeyPress($event: KeyboardEvent): void {}

  filterEvent(event: any): void {
    // On some browser, we have ctrl+d which save to shortcut and ctrl+s that open the save panel.
    // We are disabling those shortcut when this disabler directive is used.
    if ((event.ctrlKey || event.metaKey) && ( event.key === 'd' || event.key === 's')) {
      event.preventDefault();
    }
  }
}
